/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, {useContext, useState} from 'react';
import {Button, Button2, Footer, Header, Surface, Tab, Text} from 'components';
import {BaseWrapper} from '../../styles';
import {ButtonContainer, ForgotPasswordContainer} from './styles';
import {useHistory} from 'react-router-dom';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import {GlobalAuthContext, GlobalLoaderContext} from 'store/context';
import {Field, Form, Formik} from 'formik';
import {
  InputField,
  Label,
  MultiSelectField,
  Section,
  SectionHeader,
  SectionLegend,
  SectionTitle,
  SelectField
} from 'components/Form';
import {Col, Row} from 'components/Grid';
import * as Yup from 'yup';
import {FitinsurAPI, MessageCenter} from 'utils';
import TopHeader from 'components/TopHeader/index';
import Access from 'constants/Access';

export default function ForgotPasswordPage() {

  console.log("ForgotPasswordPage - BEGIN");

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);

  const [forgotPasswordState, setForgotPasswordState] = useState(authContext.forgotPassword);
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState(forgotPasswordState == true ? "Email successfully sent!" : "Please inform your e-mail and you will receive a link to change your password");

  const history = useHistory();

  const goToHomePage = () => {
    history.push('home');
  };

  const goToLoginPage = () => {
    history.push('login');
  };

  return (
    <BaseWrapper>
      <TopHeader />
      <ForgotPasswordContainer>

        <Header title="Changing Password" subtitle={forgotPasswordMessage}></Header>

        <Formik
          initialValues={{
            username: '',
          }}

          validationSchema={Yup.object({
            username: Yup.string().email('Invalid email').required('* Required field')
          })}

          onSubmit={values => {

            loading.start();

            console.log("onSubmit - BEGIN");

            if (forgotPasswordState == true) {
              setForgotPasswordMessage("Email successfully sent!");
              setForgotPasswordState(true);
              loading.stop();
              console.log("onSubmit - Existing authentication - END");
              return;
            }

            const fitinsur = new FitinsurAPI();
            const mc = new MessageCenter();

            fitinsur.requestForgotPassword(values.username, Access.APLICATION)
              .then((response) => {
                console.log(response);
                return response.json();
              })
              .then((data) => {
                console.log('requestForgotPassword - Success:', data);
                if (data.ret_code == "200") {
                  authContext.username = values.username;
                  authContext.token = data.ret_token;
                  authContext.person_product = data.ret_person_product;
                  authContext.user_region = data.ret_user_region;

                  console.log("requestForgotPassword: authContext");
                  console.log(authContext);

                  setForgotPasswordMessage("Email successfully sent!");
                  setForgotPasswordState(true);

                  setTimeout(() => goToLoginPage(), 5000);
                } else {
                  authContext.username = values.username;
                  authContext.token = "";
                  authContext.person_product = [];
                  authContext.user_region = "";
                  setForgotPasswordMessage("Error sending email");
                  setForgotPasswordState(false);
                }
                loading.stop();
              })
              .catch((error) => {
                authContext.username = values.username;
                authContext.token = "";
                authContext.person_product = [];
                authContext.user_region = "";

                console.error('requestForgotPassword - Error:', error);
                setForgotPasswordMessage("Error sending email");
                setForgotPasswordState(false);
                loading.stop();
              });

            console.log("onSubmit - END");
          }}
        >

          {(props) => (
            <Form>
              <Surface>
                <Section>

                  <Row>
                    <Col xs={12} md={8}>
                      <Field
                        name="username"
                        label="E-mail:"
                        type="text"
                        component={InputField}
                        isRequired
                        hideLabelAsterisk
                        disabled={forgotPasswordState == true}
                        originalSize
                      />
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} md={12} style={{position: "static"}}>
                      <ButtonContainer>
                        <Button
                          primary type="submit"
                          id="btnForgotPassword"
                          style={{}}
                          disabled={forgotPasswordState == true}>
                          Next
                        </Button>
                      </ButtonContainer>
                    </Col>

                  </Row>
                </Section>
              </Surface>

            </Form>
          )}

        </Formik>

        {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
      </ForgotPasswordContainer>
      <Footer />
    </BaseWrapper>

  );
}
